import { render } from "./CatalogosView.vue?vue&type=template&id=ebc4c3b4&scoped=true"
import script from "./CatalogosView.vue?vue&type=script&lang=js"
export * from "./CatalogosView.vue?vue&type=script&lang=js"

import "./CatalogosView.vue?vue&type=style&index=0&id=ebc4c3b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebc4c3b4"]])

export default __exports__